import config from '../views/chart/config/chart_api.js';
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';

const _pathUri = new PathUri(config.port, config.context);

export const service = {
  getResultsHappiness: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/statistics/emotionsToday`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
    })
  },
  
  getResultsWeeklyChart: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/statistics/weekly`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
    })
  },

  getResultsMonthlyChart: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/statistics/monthly`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
    })
  },

  getResultsAnnualChart: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/statistics/annually`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
    })
  },

}